/**
 * Empresa selecionada, lembrada entre as telas de Fases (Programas, Turmas, TurmaDetalhe).
 *
 * POR QUE ISTO EXISTE: sem lembrar, cada tela caía na primeira empresa da lista. O CS que está
 * trabalhando na leroymerlin abria Turmas, entrava numa turma, clicava em voltar — e caía em outra
 * empresa, com a turma que ele estava vendo fora da lista. O botão voltar tem de devolver o estado
 * anterior, não um estado inicial.
 *
 * Duas camadas de propósito, e a ordem importa:
 *   1. `?subdomain=` na URL — vence, porque é uma intenção explícita de navegação (um link, um
 *      voltar, um endereço colado). É o que faz o histórico do navegador funcionar de verdade.
 *   2. localStorage — o fallback, para abrir a tela pelo menu ou recarregar a página e continuar
 *      onde estava.
 *
 * O mesmo padrão do ScopeProvider, que já persiste o escopo de Configurações — aqui é só a empresa,
 * porque estas telas não têm escopo de loja/fase.
 */

const CHAVE = 'aliado_fases_empresa';

/** Empresa a usar ao abrir a tela: URL > lembrada > vazio (deixa a tela pedir). */
export function empresaInicial(subdomainDaUrl) {
    if (subdomainDaUrl) return subdomainDaUrl;
    try {
        return localStorage.getItem(CHAVE) || '';
    } catch (e) {
        return '';   // modo privado / storage bloqueado
    }
}

export function lembrarEmpresa(subdomain) {
    if (!subdomain) return;
    try { localStorage.setItem(CHAVE, subdomain); } catch (e) { /* modo privado */ }
}

/** Monta um caminho preservando a empresa, para o voltar e os links entre as telas de fases. */
export function comEmpresa(path, subdomain) {
    if (!subdomain) return path;
    const sep = path.includes('?') ? '&' : '?';
    return `${path}${sep}subdomain=${encodeURIComponent(subdomain)}`;
}
